import React, { FunctionComponent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';

import {
  RecentInsurerOptions,
  SingleSelectStepProps,
} from 'scenes/common/types';
import SelectQuestion from 'scenes/common/components/Questions/SelectQuestion';
import { SelectOptions } from 'scenes/common/components/Questions';

const STATE_KEY = 'recentInsurer';

const RecentInsurerStep: FunctionComponent<
  Pick<
    SingleSelectStepProps,
    'defaultStateValue' | 'question' | 'onNext' | 'helpText'
  > & {
    recentInsurerOptions: RecentInsurerOptions;
  }
> = ({
  defaultStateValue,
  question,
  onNext,
  recentInsurerOptions,
  helpText,
}) => {
  const [options, setOptions] = useState<SelectOptions>([]);

  const {
    formState: { isValid },
    handleSubmit,
    control,
  } = useForm({
    mode: 'onChange',
  });

  const {
    dontKnowOption,
    otherOption,
    notInsuredOption,
    mostCommonInsurerList,
    otherInsurerList,
  } = recentInsurerOptions;

  useEffect(() => {
    setOptions([
      { label: 'Most common', optionList: mostCommonInsurerList },
      { label: 'Other insurers', optionList: otherInsurerList },
      notInsuredOption,
      dontKnowOption,
      otherOption,
    ]);
  }, [
    dontKnowOption,
    mostCommonInsurerList,
    notInsuredOption,
    otherInsurerList,
    otherOption,
  ]);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        options={options}
        control={control}
        isLoading={false}
        stateKey={STATE_KEY}
        question={question}
        defaultValue={defaultStateValue}
        helpText={helpText}
        ariaRequired
      />

      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default RecentInsurerStep;
